import { REDUX_LOCAL_KEY_PREFIX } from '../../../modules/redux/constants/local-key'

export const PROFILE_KEY = {

  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',

  NAME: 'name',
  EMAIL: 'email',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  ROLE: 'role',
  COUNTRY: 'country',
  TIMEZONE: 'timezone',
  LOCALE: 'locale',
  PLATFORM: 'platform',
  DEVICE_YEAR_CLASS: 'deviceYearClass',
  IP: 'ip',
  BIRTHDAY: 'birthday',
  SHORT_BIO: 'shortBio',

  // Fitness data
  FITNESS_LEVEL: 'fitnessLevel',
  TRAINING_FREQUENCY: 'trainingFrequency',
  GYM_ACCESS: 'gymAccess',
  BODY_TYPE: 'bodyType',
  BMI: 'bmi',
  BMI_CATEGORY: 'bmiCategory',
  BMR: 'bmr',
  TOTAL_ENERGY_EXPENDITURE: 'totalEnergyExpenditure',
  GENDER: 'gender',
  GOAL: 'goal',
  GOAL_OBSTACLE: 'goalObstacle',
  DIET_TYPE: 'dietType',
  DESIRED_OUTCOME: 'desiredOutcome',
  HEIGHT: 'height',
  HEIGHT_UNIT: 'heightUnit',
  WEIGHT: 'weight',
  WEIGHT_GOAL: 'weightGoal',
  WEIGHT_UNIT: 'weightUnit',
  DISTANCE_UNIT: 'distanceUnit',

  INTEREST_FOCUS: 'interestFocus',
  INJURIES: 'injuries',
  OTHER_INJURIES: 'otherInjuries',
  WORKOUT_DURATION_GOAL: 'workoutDurationGoal',

  // Nutrition
  DAILY_CALORIE_INTAKE_GOAL: 'dailyCalorieIntakeGoal',
  DAILY_PROTEIN_INTAKE_GOAL_IN_GRAM: 'dailyProteinIntakeGoalInGram',
  DAILY_PROTEIN_INTAKE_PERCENTAGE_GOAL: 'dailyProteinIntakePercentageGoal',
  DAILY_FAT_INTAKE_GOAL_IN_GRAM: 'dailyFatIntakeGoalInGram',
  DAILY_FAT_INTAKE_PERCENTAGE_GOAL: 'dailyFatIntakePercentageGoal',
  DAILY_CARBOHYDRATE_INTAKE_GOAL_IN_GRAM: 'dailyCarbohydrateIntakeGoalInGram',
  DAILY_CARBOHYDRATE_INTAKE_PERCENTAGE_GOAL: 'dailyCarbohydrateIntakePercentageGoal',

  // Coaching
  COACH_INTENSITY_LEVEL: 'coachIntensityLevel',

  LOGGED_WORKOUTS_COUNT: 'loggedWorkoutsCount',
  LOGGED_PLANS_COUNT: 'loggedPlansCount',
  TOTAL_TIME_TRAINED: 'totalTimeTrained',
  AVERAGE_TRAINING_TIME: 'averageTrainingTime',
  MAX_TRAINING_TIME: 'maxTrainingTime',
  AVERAGE_TRAINING_VOLUME: 'averageTrainingVolume',
  MAX_TRAINING_VOLUME: 'maxTrainingVolume',
  AVERAGE_CALORIES_BURNED: 'averageCaloriesBurned',
  MAX_CALORIES_BURNED: 'maxCaloriesBurned',
  WEEKLY_WORKOUTS_COUNT_GOAL: 'weeklyWorkoutsCountGoal',

  PRIVATE_EXERCISES_COUNT: 'privateExercisesCount',
  PUBLIC_EXERCISES_COUNT: 'publicExercisesCount',

  EXPO_PUSH_TOKEN: 'expoPushToken',
  WALK_THROUGH_INDEX: 'walkThroughIndex',
  STORE_REVIEW_SHOWED_AT: 'storeReviewShowedAt',
  STORE_REVIEWED_AT: 'storeReviewedAt', // @deprecated
  LAST_RATE_US_SHOWED_AT: 'lastRateUsShowedAt',
  LAST_RATE_US_SHOWED_AT_WORKOUTS_COMPLETED_COUNT: 'lastRateUsShowedAtWorkoutsCompletedCount',
  APP_VERSION: 'appVersion',
  LAST_REGENERATED_AT: 'lastRegeneratedAt',

  // Training streak
  LAST_WORKOUT_LOGGED_AT: 'lastWorkoutLoggedAt',
  CONSECUTIVE_WORKOUTS_COUNT: 'consecutiveWorkoutsCount',
  MAX_CONSECUTIVE_WORKOUTS_COUNT: 'maxConsecutiveWorkoutsCount',

  // Meal streak
  MEAL_LOGGED_COUNT: 'mealLoggedCount',
  LAST_MEAL_LOGGED_AT: 'lastMealLoggedAt',
  CONSECUTIVE_MEAL_DAY_COUNT: 'consecutiveMealDayCount',
  MAX_CONSECUTIVE_MEAL_DAY_COUNT: 'maxConsecutiveMealDayCount',

  // Associations
  USER_ID: 'userId',

  // Associations
  WORKOUTS: 'workouts',
  PREFERENCES: 'preferences',
  PLANS: 'plans',
  FEEDBACK: 'feedback',
  FEEDBACK_REPLIES: 'feedbackReplies',
  EXERCISE_LOGS: 'exerciseLogs',
  EXERCISE_LOG_SUMMARIES: 'exerciseLogSummaries',
  ABOUT: 'about',
  MEDIA: 'media',
  TAGS: 'tags',

  // Local keys
  LOCAL_MEDIA: `${REDUX_LOCAL_KEY_PREFIX}media`,
  LOCAL_HEALTH_ACCESS_DENIED_AT: `${REDUX_LOCAL_KEY_PREFIX}healthAccessDeniedAt`,
  LOCAL_HEALTH_ACCESS_INITIALIZED_AT: `${REDUX_LOCAL_KEY_PREFIX}healthAccessInitializedAt`
}
